import { render } from "./urlIcon.vue?vue&type=template&id=17802c8a"
import script from "./urlIcon.vue?vue&type=script&lang=js"
export * from "./urlIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__